export const MODULE_NAMES = [
	'rf-hero',
	'rf-grid',
	'rf-overlay',
	'rf-parallax',
	'rf-split-flow',
	'rf-mirror',
	'rf-carrousel',
	'rf-light-table',
];
